import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import { useAuthContext } from '../../auth/useAuthContext';
import useResponsive from '../../hooks/useResponsive';
// components
import { useSnackbar } from '../../components/snackbar';
import LoadingScreen from '../../components/loading-screen';
import Iconify from '../../components/iconify/Iconify';
// sections
import AccountPersonalView from '../../sections/account/AccountPersonalView';
import HistoryListPage from './HistoryListPage';
// redux
import { useDispatch, useSelector } from '../../redux/store';
import { getUserProfile } from '../../redux/slices/profile';

// ----------------------------------------------------------------------

export default function AccountPersonalPage() {
  const isMdUp = useResponsive('up', 'md');
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, logout } = useAuthContext();

  const { userProfile } = useSelector((state) => state.profile);

  const [currentTab, setCurrentTab] = useState('profile');
  console.log(userProfile)
  const TABS = [
    {
      value: 'profile',
      label: 'Profile',
      icon: <Iconify icon="mingcute:profile-line" />,
      component: <AccountPersonalView currentUserProfile={userProfile} />,
    },
    {
      value: 'history',
      label: 'History',
      icon: <Iconify icon="mdi:receipt-text" />,
      component: <HistoryListPage userId={user?.UserID} />,
    },
  ];

  useEffect(() => {
    if (user && user.UserID)
      dispatch(getUserProfile('UserProfile', user?.UserID, 0, 999, 1, user?.UserID))
    else {
      navigate("/login")
    }
  }, [dispatch, logout, navigate, user]);

  // useEffect(() => {
  //   console.log(userProfile)
  // }, [userProfile]);

  if (!userProfile) return <LoadingScreen />;

  if (user?.UserID !== userProfile?.UserID) return <LoadingScreen />;
  
  return (
    <Container sx={{ mt: isMdUp ? 8 : 1, mb: isMdUp ? 2 : 1 }}>
      <Typography variant="h3" sx={{ mb: isMdUp ? 1 : 2 }}>Account</Typography>

      {user && user?.UserTypeID !== 1 ? (
        <>
          <Tabs value={currentTab} onChange={(event, newValue) => {
            console.log(userProfile)
            if (!userProfile?.FirstName || !userProfile?.LastName || !userProfile?.YearIntake) {
              enqueueSnackbar('Please fill in first name, last name and year of intake', { variant: 'error' });
            } else {
              setCurrentTab(newValue)
            }
          }
          }>
            {TABS.map((tab) => (
              <Tab
                key={tab.value}
                label={tab.label}
                icon={tab.icon}
                value={tab.value}
                iconPosition="start"
              />
            ))}
          </Tabs>

          {TABS.map(
            (tab) =>
              tab.value === currentTab && (
                <Box key={tab.value} sx={{ mt: 3 }}>
                  {tab.component}
                </Box>
              )
          )}
        </>
      ) : (
        <AccountPersonalView currentUserProfile={userProfile} />
      )}
    </Container >
  );
}
